import { Button, CircularProgress, styled, Tooltip } from "@mui/material";
import { getCookie } from "utils";

const PrimaryTextButton = ({
  label,
  onClick,
  startIcon,
  endIcon,
  loading,
  disabled,
  width,
  height,
  size,
  textColor,
  textDecoration,
  iconColor,
  tooltipTitle,
  ...rest
}) => {
  const userLogin = getCookie("auth", `${process.env.REACT_APP_NAME}_user`);
  return (
    <Tooltip title={tooltipTitle} placement="bottom">
      <TextButton
        variant="text"
        onClick={onClick}
        disabled={disabled}
        customWidth={width}
        textColor={textColor}
        iconColor={iconColor || userLogin?.publisher?.theme_color}
        customHeight={height}
        textDecoration={textDecoration}
        size={size}
        startIcon={loading ? <CircularProgress size={16} /> : startIcon}
        endIcon={endIcon}
        {...rest}
      >
        {label}
      </TextButton>
    </Tooltip>
  );
};

const TextButton = styled(Button)(
  ({ textColor, iconColor, customWidth, customHeight, textDecoration }) => ({
    width: customWidth || "auto",
    height: customHeight || "auto",
    "&.MuiButton-root": {
      textTransform: "none",
      color: textColor || "#263238",
      textDecoration: textDecoration,
      justifyContent: "start",
    },
    "& .MuiSvgIcon-root": {
      color: iconColor || "#9545EB",
    },
  })
);
export default PrimaryTextButton;
